import React from 'react';
import {css} from 'emotion';
import styled from 'styled-components';
import Row from './Row';
import "../../node_modules/react-id-swiper/src/styles/css/swiper.css";

/* global tw */

const Section = styled.section`
    ${tw`w-full relative mx-auto z-0 justify-start`};
    background: #0A0A0F;
    background-image:
        radial-gradient(ellipse 40% 30% at 15% 15%, rgba(170,11,202,0.06), transparent 70%),
        radial-gradient(ellipse 40% 30% at 90% 85%, rgba(201,162,255,0.04), transparent 70%);
    padding-top: 3rem;
    padding-bottom: 3rem;
    @media (min-width: 992px){
        padding-top: 5rem;
        padding-bottom: 5rem;
    }
    height: auto;
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
`
const SectionHeading = styled.h2`
    ${tw`mb-2`};
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 800;
    font-size: 2rem;
    line-height: 1.1;
    letter-spacing: -0.035em;
    color: #F5F5F7;
    margin: 0;
    width: 100%;
    display: block;
    @media (min-width: 768px) {
        white-space: nowrap;
    }
    @media (min-width: 992px){
        font-size: 2.75rem;
    }
    &::before {
        content: 'CONNECT';
        display: block;
        text-transform: uppercase;
        letter-spacing: 0.14em;
        font-size: 0.6875rem;
        font-weight: 700;
        color: #C9A2FF;
        margin-bottom: 0.875rem;
    }
    &::after {
        content: '';
        display: block;
        margin-top: 0.875rem;
        height: 2px;
        width: 2.5rem;
        background: #C9A2FF;
        border-radius: 2px;
    }
`
const SmLink = styled.a`
    ${tw`flex items-center my-2 lg:my-3 no-underline`};
    padding: 0.75rem 1.25rem;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.03);
    color: #F0ECF9;
    border: 1px solid rgba(255, 255, 255, 0.08);
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 600;
    font-size: 0.9375rem;
    margin-right: 0.75rem;
    transition: all 0.2s ease;
    &:hover {
        background: rgba(255, 255, 255, 0.06);
        border-color: rgba(201, 162, 255, 0.4);
        color: #C9A2FF;
        transform: translateY(-2px);
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.35);
    }
    img{
        ${tw`mr-2`};
        height: 18px;
        width: auto;
    }
`

class SectionSix extends React.Component{
    constructor(props){
        super(props);
    }
    componentDidMount() {
        this.setState({localStorage:JSON.parse(localStorage.getItem('vendorDetails'))})
        window.onresize = function(){
            console.log('onResize called', 'font-size: 20px, color: blue');
        }
    }
    render(){
        return(
            <Section>
                <Row>
                    <div className={css`${tw`w-full`}`}>
                        <SectionHeading>
                            Follow us on social media.
                        </SectionHeading>
                        <div className={css`${tw`flex flex-wrap w-full mt-4`}`}>
                            <SmLink href="https://www.facebook.com/zyppys/" target="_blank">
                                <img src={require('../assets/img/facebook.svg')}/>
                                Facebook
                            </SmLink>

                            <SmLink
                                href="https://www.instagram.com/zyppysluxury/"
                                target="_blank">
                                <img src={require('../assets/img/instagram.svg')}/>
                                Instagram
                            </SmLink>
                        </div>
                    </div>
                </Row>
                <img className={css`${tw`absolute pin-r pin-b z-back`}; height: 90%; opacity: 0.06;`} src={require('../assets/img/illustrations/grey-mountains.svg')} alt="Mountains" />
            </Section>

        );
    }
}


export default SectionSix;
